/*******************************************************************************
 * Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          :  App.tsx
 *
 * Project Title :  Checkout
 *
 * Description    :
 *
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 * @Author       :
 *
 * On            :
 *
 * @Version      : Version 1.0
 *
 * By            : Deepthi Bachu (E844276)
 * On            : Mar 19, 2019
 * Description   : ASDS-2443: Added Forge header and footer
 *
 * By            : H224423
 * On            : Mar 19, 2019
 * Description   : ASDS-1052 Refactored routes code. Removed redundant HashRouters and moved routes here.
 *
 ******************************************************************************/
import * as React from 'react';
import 'css/checkout.css';
import OnRouteChange from 'modules/checkout/Common/OnRouteChange';
import { Switch, Route } from 'react-router-dom';
import RouteConstants from 'modules/checkout/constants/route-constants';
import SelectAccount from 'modules/checkout/SelectAccount/selectAccount';
import PaymetricScreen from 'modules/checkout/Payment/paymetricScreen';
import RequestToAddNewAddress from 'modules/checkout/RequestToNewAddress/requestToAddNewAddress';
import NoticeRequestSuccessful from 'modules/checkout/noticeRequestSuccessful/noticeRequestSuccessful';
import RequestStatus from 'modules/checkout/RequestStatus/RequestStatus';
import PurchaseSoftware from 'modules/checkout/PurchaseSoftware/PurchaseSoftware';
import AddScmSerialNumbers from 'modules/checkout/ConfigureProduct/addScmSerialNumbers';
import UserVerification from 'modules/UserVerification';
import ShippingAndBilling from 'modules/checkout/ShippingAndBilling/ShippingAndBilling';
import MyCart from 'modules/checkout/MyCart/MyCart';
import ReviewOrder from 'modules/checkout/ReviewOrder/ReviewOrder';
import OrderSuccess from 'modules/checkout/OrderStatus/OrderSuccess';
import OrderFailure from 'modules/checkout/OrderStatus/OrderFailure';
import UserVerificationSelectAccount from 'modules/checkout/UserVerificationSelectAccount/UserVerificationSelectAccount';
import ErrorPage from 'modules/checkout/Common/ErrorPage';
import ErrorBoundary from 'modules/checkout/Common/ErrorBoundary';
import PreProcess from 'modules/PreProcess';
import ForgeHeader from 'modules/checkout/HeaderComponent/ForgeHeader';
import ForgeFooter from 'modules/checkout/FooterComponent/ForgeFooter';
import CheckoutLogOut from 'modules/checkout/Logout/CheckoutLogOut';
import OrderHistory from 'modules/checkout/OrderHistory/OrderHistory';

{/** Loading the common css file */}

class App extends React.Component<any, any> {

    render() {
        return (
            <React.Fragment>
            <ForgeHeader />
            <ErrorBoundary>
            <OnRouteChange />
            <Switch>
            <Route
          exact={true}
          path={RouteConstants.SELECT_ACCOUNT}
          component={() => (
            <SelectAccount open={true} onClose={this.props.history.goBack} />
          )}
        />
        <Route
          exact={true}
          path={RouteConstants.PAYMENT_SCREEN}
          component={PaymetricScreen}
        />
        <Route
          exact={true}
          path={RouteConstants.NEW_ADDRESS}
          component={RequestToAddNewAddress}
        />
        <Route
          exact={true}
          path={RouteConstants.SUCCESS_MESSAGE}
          component={NoticeRequestSuccessful}
        />
        <Route
          exact={true}
          path={RouteConstants.REQUEST_STATUS + '/:sfdcCaseNo'}
          component={RequestStatus}
        />
        <Route
          exact={true}
          path={RouteConstants.PURCHASE_SOFTWARE}
          component={PurchaseSoftware}
        />
        <Route
          exact={true}
          path={RouteConstants.ADD_SCM_SERIALNUMBERS}
          component={AddScmSerialNumbers}
        />
        <Route
          exact={true}
          path={RouteConstants.SHIPPING_BILLING}
          component={ShippingAndBilling}
        />
        <Route exact={true} path={RouteConstants.MY_CART} component={MyCart} />
        <Route
          exact={true}
          path={RouteConstants.REVIEW_ORDER}
          component={ReviewOrder}
        />
        <Route
          exact={true}
          path={RouteConstants.ORDER_SUCCESS}
          component={OrderSuccess}
        />
        <Route
          exact={true}
          path={RouteConstants.ORDER_FAILURE}
          component={OrderFailure}
        />
        <Route
          exact={true}
          path={RouteConstants.ORDER_HISTORY}
          component={OrderHistory}
        />
        <Route
          exact={true}
          path={RouteConstants.USER_VERIFICATION_SELECT_ACCOUNT}
          component={UserVerificationSelectAccount}
        />
        <Route exact={true} path={RouteConstants.ERROR_PAGE} component={ErrorPage} />
        <Route exact={true} path={RouteConstants.LOGOUT} component={() => <CheckoutLogOut />} />
        <Route exact={true} path={RouteConstants.USER_INFO} component={UserVerification} />
        <Route exact={true} path={RouteConstants.DEFAULT_ROUTE} component={PreProcess} />
        </Switch>
        </ErrorBoundary>
        <ForgeFooter />
        </React.Fragment>
        );
    }
}

export default (App);
